<template>
	<div class="top">
		<div class="main">
			<div style="margin-top: 100px">
				<div @click="toLink('gf')" v-if="dataInfo.gf > 0" class="item">
					<img src="../assets/img/ly/top_gf.png" class="back" />
					<img src="../assets/img/ly/top_gf2.png" class="book" />
				</div>
				<div @click="toLink('ly')" v-if="dataInfo.ly > 0" class="item">
					<img src="../assets/img/ly/top_ly.png" class="back" />
					<img src="../assets/img/ly/top_ly2.png" class="book" />
				</div>
			</div>
		</div>
		<div v-loading.fullscreen.lock="loading"></div>
	</div>
</template>

<script>
import axios from 'axios';
import { Toast } from 'vant';

export default {
	name: 'top',
	data() {
		return {
			baseUrl: process.env.VUE_APP_BASE_API,
			loading: false,
			dataInfo: {},
			token: '',
			// token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJmZjgwODA4MTdkYzYwMmQ5MDE3ZGM3OTNlOTNkMDAwYiIsImV4cCI6MTY1NDY2NTA2MH0.MlQhS6xIbix9JaqFqSHw-rKafbrOhhmp9LoZ1DPvBdg',
		};
	},
	mounted() {
		// this.getList(); //测试
		this.getToken();
		document.title = '书香中医，专属活动';
	},
	methods: {
		toLink(type) {
			if (type == 'ly') {
				this.$router.push('./H5Page?id=1cfcafa846e74069bb287cc1082cf06b');
			} else {
				this.$router.push('./H5Page?id=d273ef9e1ca94d4fb31ab03d67338285');
			}
		},
		getList() {
			this.loading = true;
			let url = this.baseUrl + '/stats/accessRecord/pageSJ';
			axios.get(url, { headers: { Authorization: 'Bearer ' + this.token } }).then((res) => {
				this.loading = false;
				if (res.data.code == 200) {
					this.dataInfo = res.data.data;
				} else {
					Toast(res.data.msg);
				}
			});
		},
		// 获取token
		getToken() {
			let that = this;
			this.$bridge.callHandler('loadToken', null, (response) => {
				let url = process.env.VUE_APP_BASE_API + '/mobile/login';
				const params = {
					appToken: response,
				};
				if (response == '' || response.length <= 0) {
					that.$bridge.callHandler('login', null, function (response) {});
					return false;
				}
				axios
					.post(url, params)
					.then((res) => {
						if (res.data.code == 200) {
							that.token = res.data.token;
							that.getList();
						} else {
							Toast(res.data.msg);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			});
		},
	},
};
</script>

<style scoped>
.top {
	/* position: relative; */
	width: 100%;
	max-width: 500px;
	height: 100vh;
	background: url('../assets/img/ly/top_back.jpg') no-repeat;
	background-size: 100% 100%;
	margin: 0 auto;
}

.main {
	position: relative;
	width: 100%;
	padding-top: 260px;
}

.main .item {
	position: relative;
	width: 80%;
	margin: 0 auto 30px;
}

.back {
	width: 100%;
}
.book {
	position: absolute;
	height: 100%;
	right: 32px;
	padding: 10px 0;
	box-sizing: border-box;
}
</style>